export default (activeTab) => ({
    activeTab,
    activeTerm: activeTab,
    publications: [],
    currentPage: 1,
    totalPages: 1,

    fetchPosts(page) {
        this.currentPage = page;  // Update the current page
        const fetchURL = `/wp-json/wp/v2/publication?publication_parent_cat=${this.activeTerm}&page=${page}&per_page=12`;

        fetch(fetchURL)
            .then((response) => {
                if (!response.ok) {
                    return response.text().then(text => Promise.reject(text));
                }

                this.totalPages = parseInt(response.headers.get('X-WP-TotalPages'));
                //console.log('Total Pages: ', this.totalPages);
                return response.json();
            })
            .then((data) => {
                this.publications = data;
                //console.log(this.publications);
            });
    },

    // Compute the range of pages to display
    displayPages() {
        if (!this.currentPage || !this.totalPages) {
            return [];
        }

        let start = Math.max(this.currentPage - 2, 1);
        let end = Math.min(this.currentPage + 2, this.totalPages);
        let range = [];

        for (let i = start; i <= end; i++) {
            if (i > 0 && i <= this.totalPages) {
                range.push(i);
            }
        }
        return range;
    },

    // we can fetch sub categories also with this function
    // so we need to specify the parent category as well
    changeTerm(termID, isSubTerm = false) {

        if (!isSubTerm) {
            this.activeTab = termID;
            this.activeTerm = termID;
        } else {
            this.activeTerm = termID;
        }

        // Reset
        this.currentPage = 1;
        this.totalPages = 1;
        this.publications = [];

        this.fetchPosts(this.currentPage);
    },

    isTabActive(termID) {
        return this.activeTab === termID;
    },

    showPagination() {
        return this.totalPages > 1;
    },

    showFirstDotsGroup() {
        return this.currentPage > 3;
    },

    // Check if the current page is the first page
    isFirstPage() {
        return this.currentPage === 1;
    },

    // Check if the current page is the last page
    isLastPage() {
        return this.currentPage === this.totalPages;
    },

    init() {
        this.fetchPosts(this.currentPage);
    },
});
